import * as React from "react";
import { VerticalLayout } from "../../components/layout/vertical/vertical-layout";

interface LayoutProps {
  hideSidebar: boolean;
  children: React.ReactNode;
}

export function Layout({
  children,
  hideSidebar,
}: LayoutProps): React.ReactElement {
  return <VerticalLayout hideSidebar={hideSidebar}>{children}</VerticalLayout>;
}
